// Task f8e48cc9 (Kostya, 06.10): only a final result asks the person to check and
// close the task; an intermediate draft is shown inside the task, without buttons.
export interface ResultHeadline {
  draft: boolean;
  mine: boolean;
  title: string;
}

export const DRAFT_NOTE = "Агент сохранил промежуточный итог. Проверять и закрывать задачу пока не нужно: итоговый результат придёт в «Решить».";

export function resultHeadline(r: { state: string; final?: boolean }, canReview: boolean): ResultHeadline {
  // Results prepared before the flag carry none: they were all final.
  const draft = r.state === "pending" && r.final === false;
  // Spec 021 — for the person who checks it, a pending final result is the canvas's
  // «Нужно от тебя» card; for everyone else it is «Готово к проверке».
  const mine = r.state === "pending" && canReview && !draft;
  const title = draft ? "Промежуточный результат — задача ещё в работе"
    : mine ? "Проверь результат — подтверди или напиши, что поправить"
    : r.state === "pending" ? "Результат ждёт проверки"
    : r.state === "confirmed" ? "Результат подтверждён"
    : r.state === "skipped" ? "Закрыто без проверки" : "Запрошены изменения";
  return { draft, mine, title };
}
